// A ‘.tsx’ file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React, { createRef } from 'react';
import ReactDOM from 'react-dom';
interface FilterDropDownListProps {
    displayProp?: string;
    valueProp?: string;
    datasource: any[];
    onChange: any;
    initialValue?: string;
}

class FilterDropDownList extends React.Component<FilterDropDownListProps, any> {
    _inputRef = createRef<HTMLInputElement>();
    constructor(props: FilterDropDownListProps) {
        super(props);

    }

    private _setInitialValue = (props: FilterDropDownListProps) => {
        if (props.initialValue) {
            var kendoDropdown = $(this._inputRef.current).data('kendoDropDownList');
            kendoDropdown.select((obj: any) => {
                if (props.valueProp) {
                    return props.initialValue === obj.toJSON()[props.valueProp];
                } else {
                    return props.initialValue === obj.toJSON();
                }
            })
        }
    }

    private _onChange = (e: any) => {
        this.props.onChange(e.sender.dataItem().toJSON());
    }

    UNSAFE_componentWillReceiveProps(nextProps: FilterDropDownListProps) {
        var kendoDropdown = $(this._inputRef.current).data('kendoDropDownList');
        kendoDropdown.dataSource.data(this.props.datasource);
        this._setInitialValue(nextProps);
    }

    componentDidMount() {
        var that = this;
        var options: any = {
            filter: "contains",
            dataSource: that.props.datasource,
            change: that._onChange
        };

        if (this.props.displayProp) {
            options.dataTextField = this.props.displayProp;
        }
        if (this.props.valueProp) {
            options.dataValueField = this.props.displayProp;
        }

        ($(this._inputRef.current) as any).kendoDropDownList(options);
        this._setInitialValue(this.props);
    }

    componentWillUnmount() {
        var kendoDropdown = $(ReactDOM.findDOMNode(this)).data('kendoDropDownList');
        kendoDropdown.destroy();
    }

    render() {
        return <input ref={this._inputRef} style={{width: "100%"}} />;
    }
}

export default FilterDropDownList;